<template>
  <div class="delivery-provider">
    <loading v-if="loading"></loading>
    <div class="header">
        <div class="layout-wrapper">
            <header id="page-topbar">
                <BaseButton variant="secondary" @click="$router.go(-1)">Quay lại</BaseButton>
            <div class="title">
                <p>Hãng vận chuyển {{params.appInfo.shortName}}</p>
            </div>
              <el-button
                v-if="!linked"
                type="primary"
                @click="integrateApp"
              >
                Liên kết ngay
              </el-button>
              <el-button
                v-if="linked"
                type="danger" plain
                @click="() => this.unLinkHeyUModal = true"
              >
                Huỷ liên kết
              </el-button>
            </header>
        </div>
    </div>
    
    <div class="boxContent boxContentExt" style="margin-top: 110px;">
        <div class="__card first-box">
          <el-row>
            <el-col :span="16">
              <div style="display:flex;">
                <div>
                  <img class="app-img" :src="params.appInfo.logo">
                </div>
                <div class="app-info">
                  <b style="font-size: 16px;">{{params.appInfo.fullName}}</b>
                  <p>{{params.appInfo.shortDescription}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8" style="display: flex;flex-direction: row-reverse;">
              <el-button plain><a style="color:none" :href="params.appInfo.reference.web" target="_blank"><img style="margin-right: 8px" src="@/assets/shipper-icons/external-link-alt.svg">Đến trang ứng dụng</a></el-button>
            </el-col>
          </el-row>
        </div>
    </div>

    <div v-if="linked" class="boxContent boxContentExt">
      <div class="__card first-box">
        <LayoutCardTitle>Thông tin liên kết</LayoutCardTitle>
        <el-form label-width="120px" style="width: 100%;" :inline="true">
          <el-row style="margin-bottom: 24px">
            <el-col :span="12">
              <el-form-item label="Số điện thoại" class="m-0">
                <el-input disabled v-model="dataItem.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Họ và tên" class="m-0">
                <el-input disabled v-model="dataItem.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Token liên kết" class="m-0">
                <el-input disabled v-model="dataItem.token"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Ngày liên kết" class="m-0">
                <el-input disabled v-model="dataItem.linkedTime"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="expired" v-if="isExpired">
          <div>
            <p>Liên kết với HeyU của bạn đã hết hạn. Bấm vào nút bên cạnh để liên kết lại.</p>
            <p>Nếu bạn dùng 1 tài khoản khác, vui lòng bấm Huỷ liên kết và liên kết với số điện thoại mới.</p>
          </div>
          <div>
            <el-button type="primary" @click="reIntegrate">Liên kết lại</el-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!linked" class="boxContent boxContentExt">
      <div class="__card first-box">
        <h1 class="__card_title">Thông tin liên kết</h1>
            <div style="width: 100%;text-align: center;">
              <p>Ứng dụng chưa được liên kết với NextShop.</p>
              <el-button @click="integrateApp" type="primary">Liên kết ngay</el-button>
            </div>
      </div>
    </div>

    <div v-if="linked" class="boxContent boxContentExt">
      <div class="__card first-box">
        <LayoutCardTitle>Lịch sử giao hàng</LayoutCardTitle>
          <div style="max-width: 100%; width: 100%">
            <b-table :items="orders" :fields="fieldTable" :per-page="perPage" :current-page="currentPage">
              <template #table-caption>
                  <div v-if="orders.length === 0">
                      <div class="text-center mt-5 mb-5 empty-return-table">
                        <p>Bạn chưa có đơn giao hàng nào</p>
                      </div>
                  </div>
              </template>
              <template #cell(processorStatusText)="data">
                  <base-tag :type="data.item.processorStatusDisplay.color">{{ data.item.processorStatusDisplay.text }}</base-tag> 
              </template>
              <template #cell(partnerShippingFee)="data">
                  {{ formatMoneyNotUnit(data.item.partnerShippingFee) }}
              </template>
              <template #cell(orderNo)="data">
                  <span @click="() => $router.push({ path: `/orders-delivery/delivery-order-detail/${data.item.id}`})" style="cursor: pointer; color:#3E69F6">{{data.item.orderNo}}</span>
              </template>
            </b-table>
            <div class="order-list-nav order-list-footer d-flex justify-content-end">
              <b-pagination
                  @change="changeCurrentPage"
                  v-model="currentPage"
                  :total-rows="rows"
                  class="bottom-pagination"
                  :per-page="perPage"
              ></b-pagination>
            </div>
          </div>
      </div>
    </div>

    <el-dialog title="Huỷ liên kết HeyU" :visible.sync="unLinkHeyUModal" width="600px" :close-on-click-modal="false" append-to-body>
        <div class="text-center">
            <div class="modal-img"><img src="@/assets/employee-and-role-icons/warning.png"/></div>
            <p style="margin-bottom: 0">Bạn có chắc chắn muốn huỷ liên kết với HeyU?</p>
        </div>
        <template slot="footer">
            <el-button class="esc-btn" type="text" @click="unLinkHeyUModal = false">Quay lại</el-button>
            <el-button
              type="primary"
              @click="unLinkHeyU"
            >
              Tôi chắc chắn
            </el-button>
        </template>
    </el-dialog>
  </div>
</template>

<script>
import { OtherService } from "@/services/other.service"
import { OrdersService } from "@/services/nextshop/orders.service";
import { formatHHmmDDMMYYYY } from "../../utils/format";
import { getStorageItem } from '@/utils/auth'
import { OrderDeliveryStatus } from "../../utils/mapping";

export default {
 data() {
    return {
        loading: false,
        linked: false,
        dataItem: {},
        perPage: 5,
        unLinkHeyUModal: false,
        params: getStorageItem('appInfo'),
        orders: [],
        fieldTable: [
            {
                label: "Mã đơn giao",
                key: "orderNo",
                show: true,
            },
            {
                label: "Mã đơn hàng",
                key: "soOrderNo",
                show: true
            },
            {
                label: "Người nhận",
                key: "customerName",
                show: true
            },
            {
                label: "Trạng thái",
                key: "processorStatusText",
                thStyle: { width: "15%", 'min-width': "50px" },
                show: true,
                thClass: "text-center",
                tdClass: "text-center",
            },
            {
                label: "Ngày giao",
                key: "checkoutAt",
                show: false
            },
            {
                label: "Phí trả ĐTGH",
                key: "partnerShippingFee",
                show: true,
                thClass: "text-center",
                tdClass: "text-center",
            },
        ],
        currentPage: 1,
        rows: 0,
        search : {
          pageNum: 1,
          pageSize: 5,
          queryString: "{furtherInstructions.params.partnerCode} == '''HEYU''' ",
          sortBy: "createdAt",
          sortType: "DESC",
          textSearch: ""
        },
        isExpired: false,
    }
 },

 async created() {
    await this.getInfoIntegrateByAppCode()
 },

 methods: {
    async getInfoIntegrateByAppCode() {
        this.loading = true;
        try {
            const res = await OtherService.getInfoIntegrateByAppCode('HEYU')
            if (res.success) {
              if (res.data.data != null) {
                this.dataItem = res.data.data
                this.dataItem.linkedTime = formatHHmmDDMMYYYY(this.dataItem.linkedTime)
                this.isExpired = res.data.data.expired
                this.linked = true
                this.getOrderByApp(this.search);
              }
            } else {this.loading = false}
        } finally {
          this.loading = false;
        }
    },

    async reIntegrate() {
      this.loading = true
      try {
          const res = await OtherService.sendSmsOtpHeyU(this.dataItem.phone);
          if (res.success) {
              let param = {
                ...this.params,
                phoneNo: this.dataItem.phone,
                tokenOTP: res.data.data.otpToken,
                name: this.dataItem.name
              }
              localStorage.setItem("appInfo", JSON.stringify(param))
              this.$router.push({ 
                  path: `/partner/integrate-app-otp`,
                  name: "integrate-app-otp",
                  component: () => import("@/pages/orders-delivery/integrate-app-otp")
              });
          }
      } finally {
          this.loading = false
      }
    },

    async changeCurrentPage(page) {
      this.loading = true
      this.currentPage = page
      this.search.pageNum = page;
      await this.getOrderByApp(this.search);
      this.loading = false
    },

    async getOrderByApp(params) {
      try {
          const response = await OrdersService.getListOrdersDelivery(params);
          if (response.success) {
            this.rows = response.data.totalElements;
            response.data.data.map((res) => {
                const { partyB, furtherInstructions } = res;
                const tmp =  {
                    ...res,
                    orderNo : res.orderNo, //Mã đơn giao
                    soOrderNo: furtherInstructions[0].params.soOrderNo, //Mã đơn hàng
                    customerName: partyB.displayName, // người nhận
                    partnerShippingFee: res.lineItemFinalizing.finalAmount / 1000, //Phí trả ĐTGH
                    checkoutAt: furtherInstructions[0].params != undefined ? formatHHmmDDMMYYYY(furtherInstructions[0].params.checkoutAt) : "", //TG xuất kho
                    processorStatusDisplay : res.processorStatus ? OrderDeliveryStatus(res.processorStatus) : null,
                    processorStatusText : res.processorStatus ? OrderDeliveryStatus(res.processorStatus).text : "",
                };
                this.orders.push(tmp)
            });
          }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    integrateApp() {
      this.$router.push({ 
        path: `/partner/integrate-app`,
        name: "integrate-app",
        component: () => import("@/pages/orders-delivery/integrate-app")
      });
    },

    async unLinkHeyU() {
      this.loading = true
      try {
        const res = await OtherService.unlinkAccountIntegrate('HEYU')
        if (res.success) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: '<h5 style="color:#67c23a">Hủy liên kết thành công</h5>',
            type: 'success'
          })
          localStorage.removeItem('appInfo');
          this.$router.push({ path:`/partners`});
        }
      } finally {
        this.loading = false
      }
    }
 }
}
</script>

<style lang="scss" scoped>

.boxContent .__card {
  max-width: 960px;
  padding: 32px;
}
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>

<style lang="scss">
.boxContent {
  margin: 12px 0;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 70%;
}

.app-img {
  min-width: 80px;
  min-height: 80px;
  background: #FFFFFF;
  border-radius: 16px;
}

.app-info {
  margin-left: 20px;
}

.app-info b {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}
.app-info p {
  margin: 5px 0 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #808890;
}

.expired {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #FFF9EC;
  border-radius: 4px;
  width: 100%;
}
</style>>
